export default __webpack_public_path__ + "static/media/triangulo.1d0441d5.png";